import { Component, Input, OnInit } from '@angular/core';
import {
	CompanyCurrencyAndTaxes,
	Summary
} from '../../../../../../shared/models/models';

@Component({
	selector: 'invoice-summary',
	template: require('./invoice-summary.html'),
	styles: [require('./invoice-summary.scss')]
})
export class InvoiceSummaryComponent {
	@Input() summary: Summary;
	@Input() companyCurrencyAndTaxes: CompanyCurrencyAndTaxes;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/invoices/invoice-update/invoice-summary/invoice-summary.ts